<template>
  <div class="yk-news">
      <el-carousel indicator-position="inside" :height="bannerHeight">
        <el-carousel-item v-for="(item, index) in imgList" :key="'banner'+index">
          <img width="100%" height="auto" alt="" title="" :src="item">
        </el-carousel-item>
      </el-carousel>
    <div class="listContent">
      <div class="screenBox">
        <div class="screen">
          <el-select filterable :clearable="true" placeholder="技术类别筛选" @change="getPageData()" v-model="openTypeSelect1" >
            <el-option v-for="(i, idx) in openTypeOption1" :key="idx+'a'" :label="i.categoryName" :value="i.id"></el-option>
          </el-select>
        </div>
        <div class="screen">
          <el-select filterable :clearable="true" placeholder="应用领域筛选" @change="getPageData()" v-model="openTypeSelect2" >
            <el-option v-for="(i, idx) in openTypeOption2" :key="idx+'b'" :label="i.categoryName" :value="i.id"></el-option>
          </el-select>
        </div>
        <div class="screen">
          <el-select filterable :clearable="true" placeholder="内容格式筛选" @change="getPageData()" v-model="openTypeSelect3" >
            <el-option v-for="(i, idx) in openTypeOption3" :key="idx+'c'" :label="i.categoryName" :value="i.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="listBox">
        <div class="list" v-for="(item,index) in dataList" :key="index+'data'" @click="clickItem(item, index)">
          <div class="listLeft">
            <div class="name">{{item.title}}</div>
            <div class="value">{{item.summarys}}</div>
            <div class="time">{{item.pubishTime}}</div>
            <div class="btn">了解详情<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="listRight">
            <img :src="item.pic" :alt="item.title" :title="item.title">
          </div>
        </div>
      </div>
      <div class="listNumber">
        <el-pagination background
          v-bind="$attrs"
          :pager-count="5"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="prev, pager, next,total,jumper"
          :total="total"
          prev-text="◀"
          next-text="▶">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      openTypeSelect1: null,
      openTypeSelect2: null,
      openTypeSelect3: null,
      openTypeOption1: [],
      openTypeOption2: [],
      openTypeOption3: [],
      dataList: [],
      total: 0,
      currentPage: 1,
      bannerHeight:document.documentElement.clientWidth*537/1920+"px"
    }
  },
  computed: {
    imgList () {
      let obj = this.bannerList.find(val => {return val.typeLabel === 'news'})
      if (obj && obj.bannerList) {
        return obj.bannerList
      }
      return []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {      
      this.currentPage =1;
      this.openTypeSelect1 = null;
      this.openTypeSelect2 = null;
      this.openTypeSelect3 = null;
      this.openTypeOption1 = [];
      this.openTypeOption2 = [];
      this.openTypeOption3 = [];
      this.dataList = [];
      console.log("asdasda");
      this.$get(`/api/news/technical`,{
          navigationId: this.$route.query.newsId
        }).then(res => {
        this.openTypeOption1 = res.data
      })
      this.$get(`/api/news/application`,{
          navigationId: this.$route.query.newsId
        }).then(res => {
        this.openTypeOption2 = res.data
      })
      this.$get(`/api/news/contentFormat`,{
          navigationId: this.$route.query.newsId
        }).then(res => {
        this.openTypeOption3 = res.data
      })
      this.getPageData()
    },
    clickItem (item, index) {
      this.$router.push({
        path: '/newsDetail',
        query: {newsId: item.id,navigationId:this.$route.query.newsId}
      })
    },
    getPageData() {
      this.$post(`/api/news/list`, {
        technicalId: this.openTypeSelect1 || '',
        applicationAreaId: this.openTypeSelect2 || '',
        contentFormatId: this.openTypeSelect3 || '',
        page: this.currentPage,
        navigationId:this.$route.query.newsId,
        pageSize: 10
      }).then(res => {
        document.documentElement.scrollTop = 0;
        this.total = res.data.totalCount;
        this.dataList = res.data.list || []
      })
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getPageData()
    }
  },
  components: {},
  created() {
    window.onreset = () =>{
      return (()=>{
        this.bannerHeight = document.documentElement.clientWidth *537/1920;
      })
    }
  },
}
</script>
<style scoped lang="stylus">
.yk-news
  width 100%
  color $c1
  .banner
    height 537px
    background-color #F1F1F5
    .bannerContent
      width $pageWidth
      height 100%
      margin 0 auto
      position relative
      .f1
        font-size 38px
        padding 80px 0 20px 0
      .f2
        height: 60px
        font-size 50px
        font-weight 600
        line-height 60px
      .more
        width 400px
        display flex
        margin-top 30px
        font-size 25px
        line-height 30px
        .item
          display flex
          cursor pointer
          &:nth-of-type(1)
            margin-right 40px
          .btn
            width 60px
            height 30px
            text-align center
            border 2px solid $c1
            border-radius 50px
            line-height 30px
            margin 0 5px
            cursor pointer
  .listContent
    width $pageWidth
    margin: 68px auto 0
    height auto
    .screenBox
      display: flex
      justify-content: center
      width 100%
      .screen
        width 380px
        height 62px
        margin 0 11px
    .listBox
      .list
        display: flex
        justify-content: space-between
        padding 75px 20px 36px
        margin: 0 70px
        border-bottom 1px solid #F1F1F5
        cursor pointer
        &:nth-child(1)
          padding-top 55px
        .listLeft
          width 730px
          padding-top 7px
          .name
            width 100%
            font-size: 26px
            color: #202020
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            margin-bottom 25px
          .value
            width 100%
            height 46px
            font-size: 16px
            color: #656565
            line-height 23px
            overflow: hidden
            text-overflow: ellipsis
            display: -webkit-box
            -webkit-line-clamp: 2
            -webkit-box-orient: vertical
            margin-bottom: 28px
          .time
            font-size: 16px
            color: #656565
            line-height: 23px
            margin-bottom: 49px
          .btn
            display: flex
            align-items: center
            justify-content: center
            width: 142px
            height: 53px
            font-size: 16px
            color: #04469D
            border: 1px solid #03459D
            position relative
            .el-icon-arrow-right
              margin-left 10px
              color #fff
              z-index 1
              font-size 12px
            &:before
              content ''
              width 15px
              height 15px
              position absolute
              top 50%
              right 26px
              transform translate3d(0, -50%, 0)
              border-radius 50%
              background-color #03459D
              z-index 0
        .listRight
          width 405px
          height 302px
          background: #F1F1F5
          border-radius: 5px
          overflow: hidden
          img
            width 100%
            height 100%
            object-fit: cover
            animation imgNormal 0.6s ease forwards
        &:hover
          .listLeft
            .name
              color #03459D
            .btn
              background-color #03459D
              color #fff
              .el-icon-arrow-right
                color #03459D
              &:before
                background-color #ffffff
          .listRight
            img
              animation imgBig 0.6s ease forwards
    .listNumber
      display: flex
      justify-content: center
      height 43px
      margin: 54px auto 51px
      .el-pagination
        button
          height 100%
          width 37px
          color: #ffffff
          background: #03459D
        ul
          height 100%
          li
            height 100%
            width 37px
            line-height: 39px
            background: #FFFFFF
            border: 1px solid #DDDDDD
          .active
            background: #03459D
            color: #ffffff
@keyframes imgBig
  0%
    transform scale(1)
  100%
    transform scale(1.1)
@keyframes imgNormal
  0%
    transform scale(1.1)
  100%
    transform scale(1)
@media screen and (max-width: 900px)
  .yk-news
    .banner
      background-color #E5EBF1
      .bannerContent
        width 100%
        .f1
          margin-left 1rem
          font-size 1.3rem
        .f2
          margin-left 1rem
          font-size 1.6rem      
          line-height 2rem  
        .more
          margin-left 1rem
          font-size 1rem 
          line-height 1.1rem  
          .item
            .btn
              width 2rem
              height 1.2rem
              line-height 1.1rem  
    .listContent
      width 88%
      margin 1.04rem
      .screenBox
        display: flex
        flex-direction: column
        justify-content: top
        width 100%
        .screen
          width 100%
          margin: .4267rem 0 0
          &:nth-child(1)
            margin-top: 0
          .el-select
            .el-input
              .el-input__inner
                font-size: .7rem
              .el-select__caret
                font-size: .7rem
                height 1.5rem
                line-height: .7rem
      .listBox
        .list
          display: flex
          flex-direction: column-reverse
          justify-content: space-between
          padding 0px 0 0 0
          margin: 1.1467rem 0
          border-bottom 0
          background: #F7F7F7
          border-radius: 0px 10px 10px 0px
          &:nth-child(1)
            padding-top 0
          .listLeft
            width 100%
            padding-top 28px
            padding-left .3733rem
            .name
              width 100%
              height .8rem
              font-size: .8rem
              line-height: .8rem
              margin-bottom .4533rem
            .value
              width 100%
              height .7rem
              font-size: .7rem
              line-height: .7rem
              overflow: hidden
              text-overflow: ellipsis
              display: -webkit-box
              -webkit-line-clamp: 1
              -webkit-box-orient: vertical
              margin-bottom: .6667rem
            .time
              display: none
            .btn
              display: none
          .listRight
            width 100%
            height 8.64rem
      .listNumber
        display: none
</style>
<style lang="stylus">
.yk-news
  .listContent
    .screenBox
      .screen
        .el-select
          width 100%
          height 100%
        .el-input
            height 100%
            .el-input__inner
              height 100%
              line-height:60px
              font-size: 24px
              padding 0 20px
              font-weight: bold
              border: 1px solid #D3D3D3
              &::placeholder
                color: #202020
            .el-select__caret
              font-size: 26px
              color: RGBA(32, 32, 32, 1)
          .is-focus
            .el-input__inner
              border: 2px solid #03459D
              &::placeholder
                color: #04469D
            .el-select__caret
              color: #03459D
          .el-select-dropdown
            margin: 0
            padding 0
.el-input__icon
  line-height 60px
.el-select-dropdown__item
  font-size 18px
  height 40px
  line-height 40px
</style>